import { useEffect, useState } from "react";

// Pages live after "#/" so the site works from any static host with no server rules.
// A hash that does not start with "#/" (such as the sign-in link's session) is left
// for supabase-js and shows the dashboard.

export function currentPath(): string {
  const hash = window.location.hash;
  return hash.startsWith("#/") ? hash.slice(1) : "/";
}

/** Asked before leaving a page with unsaved changes. */
let leaveGuard: (() => boolean) | null = null;
export function setLeaveGuard(guard: (() => boolean) | null) {
  leaveGuard = guard;
}

export function navigate(path: string) {
  if (leaveGuard && !leaveGuard()) return;
  window.location.hash = path;
}

export function usePath(): string {
  const [path, setPath] = useState(currentPath);
  useEffect(() => {
    let last = currentPath();
    const onChange = () => {
      const next = currentPath();
      if (next === last) return;
      // A link or the back button: undo the change if the page has unsaved work.
      if (leaveGuard && !leaveGuard()) {
        window.history.replaceState(null, "", "#" + last);
        return;
      }
      last = next;
      setPath(next);
    };
    window.addEventListener("hashchange", onChange);
    return () => window.removeEventListener("hashchange", onChange);
  }, []);
  return path;
}
